import React, { useState, useEffect } from 'react';
import { Loader } from 'react-feather';
import { dispatch } from '@wordpress/data';
import { store } from 'jkit-core/store';
import { fetchDemoData, fetchDemoCategories } from '../helper/axios';
import DemoItems from './demo/demo-items';

const Demo = (props) => {
    const [loading, setLoading] = useState(true);

    const initDemoState = {
        keyword: '',
        like: false,
        imported: false,
        paging: 1,
    };

    fetchDemoCategories().then(results => {
        dispatch(store).demoCategories({
            'demoCategoryData': results,
        });
    });

    fetchDemoData().then(result => {
        dispatch(store).initialDemoData({
            'demoData': result['demos'],
        });
        setLoading(false);
    });

    const { plugins } = window['JkitDashboardOption'] || window['jkitWizard'];
    dispatch(store).initialPluginData({
        'installedPlugin': plugins,
    });
    dispatch(store).initialModalData({
        'demoContentData': initDemoState
    });

    return <div className="f-demo-wrapper">
        {loading ? <div className="loading">
            <Loader size={28}/>
        </div>:
            <DemoItems {...props}/>}
    </div>;
};

export default Demo;
